import { Grid, Box } from '@mui/material';
import LessonCard from './components/LessonCard';
import { LessonDetail } from '@/services/syllabusService';

interface LessonsProps {
    lessons: LessonDetail[];
}

function Lessons({ lessons }: LessonsProps) {
    return (
        <Box sx={{ width: '100%' }}>
            {/* Lessons Grid */}
            <Grid container spacing={3}>
                {lessons.map((lesson) => (
                    <Grid item xs={12} sm={6} md={4} key={lesson.id}>
                        <LessonCard lesson={lesson} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default Lessons;
